export const tribeTraitsLengthValidator = values => {
  if (values.publicTags && values.publicTags.length > 10) {
    return { publicTags: 'You can choose up to 10 traits per tribe.' }
  }
  return {}
}
